import styled, { x } from '@xstyled/styled-components';
import React, { FC, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import { select } from '~/lib/select';
import {
  SequenceStore,
  useSequenceStore
} from '~/training/sequence/SequenceStore';
import {
  LeftMatchItem,
  QuizMatchStore,
  RightMatchItem,
  useQuizMatchStore
} from '../QuizMatchStore';
import { LeftButton } from './LeftButton';
import { RightButton } from './RightButton';

const selector = (s: QuizMatchStore) => select(s, 'leftItems', 'rightItems');
const sequenceSelector = (s: SequenceStore) =>
  select(s, 'addBlocker', 'removeBlocker', 'blockers');

const QuizMatchUIBlock = styled.div`
  width: 100%;
  height: 100%;
  @media (max-width: sm) {
    .LeftShape {
      background-color: #e9e9e9;
      width: 140px;
      padding-left: 20px;
      font-size: 14px;
    }
    .LeftShape:after {
      border-left: 30px solid #e9e9e9;
    }
    .LeftShapeIsActive {
      border: 1px solid red;
    }
    .LeftBorder {
      margin-right: 0px;
    }
    .RightShape {
      background-color: #e9e9e9;
      width: 140px;
      font-size: 14px;
      .LeftBorder {
        z-index: 20;
        margin-right: 30px;
        .LeftShape {
          padding-left: 20px;
          width: 98%;
        }
      }
    }
    .RightShape:before {
      border-left: 32px solid var(--color-white);
      z-index: 10;
      border-bottom-color: #e9e9e9;
    }
    .RightShape:after {
      border-left: 30px solid var(--color-white);
      border-top-color: #e9e9e9;
    }
    .gridTemplate {
      padding: 0px;
    }
    .LeftBorder {
      width: 160px;
    }
    .LeftBorder.active {
      box-shadow: -16px 2px 16px -5px var(--color-accent-dk);
    }
    .RightBorder {
      width: 145px;
    }
    .DropBoxRightPart {
      width: 180px;
    }
  }
`;

export const QuizMatchMobileRoot: FC<{ id: string }> = ({ id }) => {
  const [lastLeftId, setLastLeftId] = useState('0');
  const mobileMatch = useQuizMatchStore(s => s.mobileMatch);
  const { leftItems, rightItems } = useQuizMatchStore(selector, shallow);
  const { addBlocker, removeBlocker, blockers } = useSequenceStore(
    sequenceSelector,
    shallow
  );

  const _oneLastElement = leftItems.filter(i => (!('show' in i) || i.show ? true : false)).pop();

  useEffect(() => {
    if (_oneLastElement && leftItems) {
      setLastLeftId(_oneLastElement?.pairId);
    }
  }, [leftItems]);

  useEffect(() => {
    if (
      !rightItems.find(el => !(el.leftItem && el.leftItem.pairId == el.pairId))
    )
      return;
    addBlocker(id);
    return () => removeBlocker(id);
  }, [leftItems, lastLeftId]);

  const onClickLeftButton = (id: string) => {
    setLastLeftId(id);
  };

  const onClickRightButton = (
    leftElement: LeftMatchItem,
    rightElement: RightMatchItem
  ) => {
    if (lastLeftId && lastLeftId !== '0') {
      mobileMatch(leftElement, rightElement);
      setLastLeftId('0');
    }
  };

  return (
    <QuizMatchUIBlock>
      <x.div
        w="100%"
        h="100%"
        p="xxl"
        display="grid"
        gridTemplateColumns="1fr 1fr"
        className="gridTemplate"
      >
        <x.div
          display="flex"
          flexDirection="column"
          gap="md"
          alignItems="flex-start"
          opacity={lastLeftId != '0' ? '0.5' : '1'}
        >
          {leftItems.map(i => {
            if (i.show !== false) {
              return (
                <LeftButton
                  active={lastLeftId == i.pairId}
                  key={i.pairId}
                  {...i}
                  onClick={() => onClickLeftButton(i.pairId)}
                />
              );
            }
          })}
        </x.div>
        <x.div
          display="flex"
          flexDirection="column"
          gap="md"
          alignItems="flex-end"
          opacity={lastLeftId == '0' && blockers.length ? '0.5' : '1'}
        >
          {rightItems.map(i => (
            <RightButton
              key={i.pairId}
              {...i}
              onClickLeftButton={onClickLeftButton}
              onClick={() =>
                onClickRightButton(
                  leftItems.find(
                    el => el.pairId == lastLeftId
                  ) as LeftMatchItem,
                  i
                )
              }
            />
          ))}
        </x.div>
      </x.div>
    </QuizMatchUIBlock>
  );
};
